import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  Signal
} from '@angular/core';
import { FormattedCurrencyPipe } from '../../../../shared/pipes/formatted-currency.pipe';

interface OrderPriceCardField {
  name: string;
  value: string | number;
}

@Component({
  selector: 'app-order-prices-card',
  templateUrl: './order-prices-card.component.html',
  imports: [FormattedCurrencyPipe],
  styleUrl: './order-prices-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderPricesCardComponent {
  taxes: InputSignal<string | number> = input<string | number>(10);
  deliveryFee: InputSignal<string | number> = input<string | number>(20);
  tip: InputSignal<string | number> = input<string | number>(30);
  couponCode: InputSignal<string | number> = input<string | number>(40);
  points: InputSignal<string | number> = input<string | number>(50);

  subtotal: InputSignal<string | number> = input<string | number>(100);
  total: InputSignal<string | number> = input<string | number>(150);

  fields: Signal<OrderPriceCardField[]> = computed(() => [
    { name: 'Taxes', value: this.taxes() },
    { name: 'Delivery Fee', value: this.deliveryFee() },
    { name: 'Tip', value: this.tip() },
    { name: 'Coupon Code', value: `-${this.couponCode()}` },
    { name: 'Points', value: this.points() }
  ]);
}
